<template>
  <v-dialog
    :value="value"
    :persistent="persistent"
    max-width="390"
    @input="$emit('input', $event)"
  >
    <v-card>
      <v-card-title class="headline">
        Editar senha
      </v-card-title>
      <v-card-text>
        <p>
          Para continuar adicione uma nova senha e
          complete as informações do seu perfil
        </p>
        <v-form v-model="valid">
          <v-text-field
            v-model="currentPw"
            name="pwCurrent"
            label="Senha Atual"
            placeholder="Digite a senha atual"
            counter
            :type="showPassword ? 'text' : 'password'"
            :append-icon="showPassword ? 'mdi-eye' : 'mdi-eye-off'"
            @click:append="showPassword = !showPassword"
          />
          <v-text-field
            v-model="password1"
            name="pwNew1"
            label="Senha"
            placeholder="Digite a nova senha"
            counter
            :type="showPassword ? 'text' : 'password'"
            :append-icon="showPassword ? 'mdi-eye' : 'mdi-eye-off'"
            :rules="passwordRules({match: password2})"
            @click:append="showPassword = !showPassword"
          />
          <v-text-field
            v-model="password2"
            name="pwNew2"
            label="Repita a senha"
            placeholder="Repita a nova senha"
            counter
            :type="showPassword ? 'text' : 'password'"
            :append-icon="showPassword ? 'mdi-eye' : 'mdi-eye-off'"
            :rules="passwordRules({match: password1})"
            @click:append="showPassword = !showPassword"
          />
        </v-form>
      </v-card-text>

      <v-card-actions>
        <v-spacer />
        <v-btn
          color="primary"
          rounded
          large
          :disabled="!valid"
          @click="onUpdateClick"
        >
          Atualizar
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
const genCompData = () => ({
  showPassword: false,
  currentPw: '',
  password1: '',
  password2: '',
  valid: false,
});

export default {
  props: {
    value: {
      type: Boolean,
      default: false,
    },
    persistent: {
      type: Boolean,
      default: false,
    },
  },
  data: () => genCompData(),
  computed: {
    passwordRules() {
      return ({ match } = {}) => {
        let testMatch = false;
        const { password1, password2 } = this;
        if (match === password1) {
          // matching pass2 field against pass 1 field
          testMatch = true;
        }
        if (match === password2 && this.password2 !== '') {
          // matching pass1 field against pass 2 field
          testMatch = true;
        }
        return [
          this.$rules.required(),
          this.$rules.min(6),
          testMatch ? this.$rules.match(match, 'As senhas') : () => true,
        ];
      };
    },
  },
  watch: {
    value() {
      const newData = genCompData();
      Object.keys(newData).forEach(
        (key) => { this[key] = newData[key]; },
      );
    },
  },
  methods: {
    onUpdateClick() {
      this.$emit('input', !this.value);
      this.$emit('change', { currentPasword: this.currentPw, newPassword: this.password2 });
    },
  },
};
</script>
<style lang="stylus">
  .v-card__title.headline {
    padding: 0 0 5px;
  }
</style>
